import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'modal-summary-table',
  templateUrl: './modal-summary-table.component.html',
  styleUrls: ['./modal-summary-table.component.scss'],
})
export class ModalSummaryTable {

  @Input() title: string;
  @Input() route: any;

  constructor(
    private modal: ModalController,
  ) { }

  close() {
    this.modal.dismiss({ confirm: false });
  }

  confirm() {
    this.modal.dismiss({ confirm: true });
  }
}
